import { useState } from 'react';
import CreateMembership from '../CreateMembership/CreateMembership';
import SuccessMessage from '../CreateMembership/SuccessMessage';

export default function RegisterPage({ isJoinSheet = false, onAuthSuccess }) {
  const [hidePage, setHidePage] = useState(false);
  const [user, setUser] = useState({});

  return hidePage ? (
    <SuccessMessage
      userId={user.id}
      name={user.name}
      email={user.email}
      confirmationEmailStatus={user.confirmation_email_status}
      confirmationEmailErrorCode={user.confirmation_email_error_code}
      confirmationEmailErrorMessage={user.confirmation_email_error_message}
      setHidePage={setHidePage}
      isJoinSheet={isJoinSheet}
    />
  ) : (
    <CreateMembership
      setHidePage={setHidePage}
      setUser={setUser}
      isJoinSheet={isJoinSheet}
      onSuccess={onAuthSuccess}
    />
  );
}
